var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isAuthenticated)?_c('main-header'):_vm._e(),(_vm.isAuthenticated)?_c('sub-header'):_vm._e(),_c('v-content',{staticClass:"app__container"},[_c('router-view')],1),(_vm.isAuthenticated)?_c('bottom-nav'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }